import axios from "axios";
import { NETWORK_CALL_FAILED, ActiveExperimentsResponse } from "redmond";
import { platformApiApi } from "@capone/platform-api";
import { trackEvent } from "../trackEvent";
import { config } from "../../config";

export const fetchActiveExperiments = (): Promise<ActiveExperimentsResponse> =>
  new Promise(async (resolve, reject) => {
    try {
      const res = await platformApiApi(axios).apiV0ExperimentsActivePut({
        baseURL: config.baseURL,
      });
      resolve(res.data as unknown as ActiveExperimentsResponse);
    } catch (e) {
      trackEvent({
        eventName: NETWORK_CALL_FAILED,
        properties: {
          url: window.location.pathname,
        },
      });
      reject(e);
    }
  });
